var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"light":""}},[_c('v-card-title',[_c('TheBreadcrumbs')],1),_c('v-divider'),_c('v-card-text',{staticClass:"pt-0"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }